import React, {useEffect, useState} from "react";
import { Popover,Dropdown,Button, Tag } from "antd";
// import AttachmentBox from "../../AttachmentBox/AttachmentBox";
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import { markUnmarkFavourite,editQuestionText,getFavouriteData } from "../../API/api";
// import Button2 from "../../Button2/Button2";
import Button2 from "../../NewComponent/Button2/Button2";
import { DeleteOutlineOutlined, EditOutlined, FavoriteBorderOutlined, LocalFireDepartment, PeopleAltOutlined,HelpOutline, CheckCircleOutline  } from "@mui/icons-material";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
// import Tags from "../answerBox/ExpertQA/Tags";
import Tags from "../../NewComponent/answerBox/KeyTagQA/Tags";
import { momentit } from "../../utils";
import {toast} from 'react-toastify';
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";
import Answer from "./Answer";
import NameInfo from "./NameInfo";
import { ReactComponent as HeartIcon } from "../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../Icons/heartSelect.svg";
import { handleError } from "../../utils";
import { useNavigate } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import { CURRENT_ROLE } from "../../API/url";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";

export default function QuestionBox({ data,tab }) {
	const dispatch = useDispatch()
	const {getTabValue,recommendData,preservePreviousRecommendData, openQuestionsData,advanceFilterModalToggle,getSelectedQuestion,deleteSelectedOpenQuestionUuid,updateFavouriteTabData,updateSharedByTabData,IsLoadingFavouritetab,updateSharedWithTabData} = bindActionCreators(Actions,dispatch)
	const [isFavorite, setFavorite] = useState(data.favourite);
	const openState = useSelector((state)=>state.openQuestions)
	const favoriteState = useSelector((state)=>state.favouriteQuestions)
	const sharedByMeState = useSelector((state)=>state.sharedBy)
	const sharedWithMeState = useSelector((state)=>state.sharedWith)
	const [edit,setEdit] = useState(false)
	const [editQuestion,setEditQuestion] = useState(data.text)
	const [addditionalContext, setAdditionalContext] = useState(data.additionalContext && data.additionalContext !== '' ? data.additionalContext : '')
	const [clarified, setClarified] = useState(false)
	const [checkQuestionValue, setCheckQuestionValue] = useState('')
	const [isHovered, setIsHovered] = useState(false);

	const navigate = useNavigate()

	const isButtonDisabled =   data.clarificationStatus 
	? (data.text === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '' || addditionalContext === ''
	: editQuestion === '';

	const containerStyle = {
    border: "1px solid #E0E2E6",
    borderRadius: "16px",
    background: "#FFFFFF",
    boxShadow: "0px 4px 16px 0px #1018280F",
    padding: "24px 36px 24px 36px",
    minHeight: "100px",
    marginBottom: '24px'
  };

	const onClickEdit = () => {
		setEdit(!edit)
	}


	const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };

	const fetchNewFavoriteData = () => {
		if (favoriteState.searchQuery === '') {
			let status = "getfavourite";
			let category = 1;
			getFavouriteData(favoriteState.pageNo, favoriteState.sortFilter.origValue,
				favoriteState.sortFilter.sortOrder,
				favoriteState.sortChange,
				favoriteState.domains,
				category,
				status).then((res) => {
					if (res === undefined) return
					if (res.data.success) {
						IsLoadingFavouritetab(false);
						updateFavouriteTabData({
							data: res.data.data,
							count: res.data.count,
							value: tab
						});
					}
				}).catch((err) => handleError(err))
		}
	}

	const onCLickFavorite = (key, flag) => {
		if (key === undefined) return
		markUnmarkFavourite(key.questionUuid).then((res) => {
			if (res === undefined) return;
			if (res.data.success) {
				setFavorite(flag);
				if (tab === 1) {
					let newOpenData = favoriteState.data.filter(obj => {
						if (obj.questionUuid !== key.questionUuid) {
							return obj
						}
					})
					// console.log(newOpenData,'check new open data')
					updateFavouriteTabData({ data: newOpenData, count: favoriteState.totalCount - 1, value: 1 })
				}
				if (tab === 2) {
					let newSharedByMeData = sharedByMeState.data.filter((obj, ind) => {
						if (obj.questionUuid === key.questionUuid) {
							obj.favourite = flag
							return obj;
						}
						return obj;
					})
					updateSharedByTabData({ data: newSharedByMeData, count: sharedByMeState.totalCount, value: tab })
					fetchNewFavoriteData()
				}
				if(tab === 3)
				{
					let newSharedWithMeData = sharedWithMeState.data.filter((obj, ind) => {
						if (obj.questionUuid === key.questionUuid) {
							obj.favourite = flag
							return obj;
						}
						return obj;
					})
					updateSharedWithTabData({ data: newSharedWithMeData, count: sharedWithMeState.totalCount, value: tab })
					fetchNewFavoriteData()
				}
			}
		});
	};

	const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    // width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    // marginBottom:'5px'
    // paddingLeft: "7px",

  };
  const textStyles = {
    fontSize: "24px",
    color: "#2A364A",
    lineHeight: "32px",
    fontWeight: "400",
    wordBreak: 'break-word',overflowWrap: 'break-word',
		// width:'100%',
	cursor:'pointer',
	textDecoration:
	   isHovered
		? "underline"
		: "none"
  };

	const buttonStyles = {
		padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
    color: 'rgb(255, 255, 255)',
    border: '1px solid rgb(255, 255, 255)',
    height: '40px',
    minWidth: '88px',
    background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
    marginBottom: '14px',
		// opacity: (editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext) ? '0.34' : null,
		// opacity:data.clarificationStatus ? ((data.text === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '') ? '0.34' : (editQuestion === '') ? '0.34' : null : false,
		// cursor:(editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext || data.additionalContext === '')  ? 'not-allowed' : 'pointer'
		opacity: isButtonDisabled ? '0.34' : null,
		cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
	}

	const buttonStylesCancel = {
		padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '24px',
    fontWeight: 400,
    boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
    color: 'black',
    border: '1px solid rgb(224, 226, 230)',
    height: '40px',
    minWidth: '88px',
    background: '#fff',
    marginBottom: '14px',
	}

	const renderToast = (message) => {
		return (
			<>
			<span style={{fontSize:'12px'}}>
				{message}
			</span>
			</>
		)
	}



	const onClickUpdateButton = () => {

		const payload = {
			questionUuid: data.questionUuid,
			questionText: editQuestion,
			domain: data.domain,
			postedDate: data.postedTimestamp,
			additionalContext: addditionalContext
		}
		// console.log(payload.questionText,'cehck q1')
		editQuestionText(payload).then((res)=>{
			if(res === undefined) return 
			if(res.data.success)
			{
				// let newData = openState.openData.filter((obj, ind) => {
				// 	if (obj.questionUuid === data.questionUuid) {
				// 		obj.text = editQuestion
				// 		if (obj.additionalContext) {
				// 			obj.additionalContext = addditionalContext
				// 			return obj;
				// 		}
				// 		return obj;
				// 	}
				// })
				let newData = [...openState.openData]
				newData.filter((obj, ind) => {
					if (obj.questionUuid === data.questionUuid) {
						obj.text = editQuestion
						obj.additionalContext = addditionalContext
						if (obj.clarificationStatus) {
								obj.clarificationStatus = false;
								setClarified(true)
								return obj;
						}
					}
				})
				openQuestionsData(newData)
				toast.success(renderToast(res.data.message), {
					position: toast.POSITION.TOP_RIGHT,
				});
				setEdit(false)
			}
		})
	}

	const onClickDeleteButton = () => {
		advanceFilterModalToggle({ bool: true, value: "deleteQuestion" });
		getSelectedQuestion(data);
		deleteSelectedOpenQuestionUuid(data.questionUuid);
};

const onClickWatchlistModal = (data) => {
	advanceFilterModalToggle({ bool: true, value: 'addToWatchlistOpenTab' });
	getSelectedQuestion(data);
}

const additionalContextStyles = {
	border: '1px solid rgb(246, 247, 248)',
	marginBlock: '10px',
	borderRadius: '6px',
	background: 'rgb(246, 247, 248)',
	padding: '12px',
	minHeight: '48px',
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap'
}

const clarificationBoxStyles = {
	background: '#f9ede5',
	padding: '5px 10px',
	borderRadius: '4px',
	marginBottom: '12px'
}

const onButtonCancel = () => {
	setEdit(false)
	setEditQuestion(data.text)
	setAdditionalContext(data.additionalContext)
}

	const QuestionTextComponent = () => {

		return (
			<>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
					<div style={textStyles} onMouseEnter={() => setIsHovered(true)}
						onMouseLeave={() => setIsHovered(false)} onClick={() =>  generatingRelatedQ(data)}>
						{/* {data.userInitiatedCuration && (
							<Tag color={'#6c94ba'} style={{fontWeight:'bold'}}>Requested an update</Tag>
						)} */}
						{/* {data.express && (
							<>
								<FireIcon style={{ marginRight: '5px' }} />
							</>
						)} */}
						{data.text}
					</div>
					<div style={{display:'flex',alignItems:'center'}}>
						{
							clarified && (
								<Tag style={{fontWeight:'bold',backgroundColor:'green',color:'white'}} icon={<CheckCircleOutline style={{ marginRight: '5px', fontSize: '18px', fontWeight: 'bold' }} />}>Request Clarified</Tag>
							)
						}
						{/* {data.clarificationStatus && (
							<>
								<Tag onClick={() => setEdit(true)} color={'#fd7400'} icon={<HelpOutline style={{ marginRight: '5px', fontSize: '18px' }} />} style={{ fontWeight: 'bold', cursor: 'pointer' }}>Expert requested for clarification</Tag>
							</>
						)} */}
						{data.seekerAttachments && data.seekerAttachments.length > 0 && (
							<Popover title={renderAttachemnt(data.seekerAttachments)}>
								{" "}
								<Button2 onClickFunc={onCLickFavorite}>
									<DownloadIcon />
								</Button2>
							</Popover>)}
						{/* {
							data.answersList.length > 0 &&
							<DropdownComponent question={data} />
						} */}
						{/* <div style={{cursor:'pointer'}} onClick={()=>onCLickFavorite(data,data.favourite)}>
						{data.favourite ? <HeartSelectedIcon /> : <HeartIcon />}
						</div> */}
						{
							data.favourite ? <div style={{cursor:'pointer'}} onClick={()=>onCLickFavorite(data,false)}>                <TooltipComp title="Favorite question">
<HeartSelectedIcon /></TooltipComp></div> : <div style={{cursor:'pointer'}} onClick={()=>onCLickFavorite(data,true)}><TooltipComp title="Favorite question"><HeartIcon /></TooltipComp></div>
						}
               {/* {CURRENT_ROLE==='Expert'&&<div>&nbsp;<i className="fa fa-edit" style={{fontSize:'20px', marginTop:'5px', color:'#ACB6C6', cursor:'pointer'}} onClick={()=>onClickEdit()}></i></div>} */}
			   </div>
				</div>
			</>
		)
	}

	const noAnswerText = {
		padding: '2px 6px',
		marginLeft: '10px',
		fontSize: '1.2em',
		borderRadius: '3px',
		color: '#fd7400',
		fontWeight: 'bold'
	}

	const hrStyles = {
		border: 'none', 
		borderBottom: '1.5px solid', 
		borderImage:'linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%) 1', 
		borderImageSlice: 1,
		marginTop:'15px',
		marginBottom:'12px'
	  };

	  const generatingRelatedQ = (data) =>{
		getTabValue(tab)
		if(data.text === undefined){
		  data.text = data.questionText;
		}
		if(!data.reusableThreadQA){
		  let payload ={
			data:{
			  id:data.questionUuid,
			text:data.text
			}
		  }
		  preservePreviousRecommendData([])
		  recommendData(payload);
		  navigate(`${Home_PAGE_URL}recommend`,{ state: { message: "Hello from React Router!" } });
		}else if(data.reusableThreadQA){
		  if(data.status === 'accepted'){
			let payload ={
			  data:{
				id:data.questionUuid,
			  text:data.text
			  }
			}
			preservePreviousRecommendData([])
			recommendData(payload);
			navigate(`${Home_PAGE_URL}recommend`);
		  }
		}
	
	  }

	return (
		<>
			<div style={containerStyle}>
			{edit && data.clarifications && data.clarifications.length > 0 && (
					<>
					<div style={clarificationBoxStyles}>
							<span className="clarificationHeading">Clarification request from expert <span className="clarificationHeadingSubText">(Clarify question to allow an expert to provide the best answer)</span></span>
						<ul>
							{data.clarifications.map((obj,ind)=>{
								return(
									<><li key={ind}>{obj.context}</li></>
								)
							})}
						</ul>
					</div>
					</>
				) }
			{<QuestionTextComponent />}
				{edit &&
					(
						<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
							{
								data.express && <FireIcon style={{ marginRight: '4px' }} />
							}
							<div style={{ width: '100%' }}>
								<div style={textStyles}>
									<textarea wrap="soft" style={{ border: '1px solid rgb(224, 226, 230)', width: '100%', padding: '12px', borderRadius: '6px', outline: 'none', resize: 'none' }} rows={1} type={"text"} value={editQuestion} onChange={(e) => setEditQuestion(e.target.value)} />
								</div>
							</div>
						</div>
					)}
			{ edit === false && data.additionalContext && data.additionalContext !== '' && (
				<>
				<div style={additionalContextStyles}>
					{data.additionalContext}
				</div>
				</>
			)}
				{
					data.seekerAttachments && data.seekerAttachments.length > 0 && edit &&
					<div style={{ marginTop: '10px',width:'52px' }}>
						{
							<Popover title={renderAttachemnt(data.seekerAttachments)}>
								{" "}
								<Button2 onClickFunc={onCLickFavorite}>
									<DownloadIcon />
								</Button2>
							</Popover>
						}
					</div>
				}
			<span style={{color:'#5C667B',fontWeight:400,fontSize:'14px',marginTop:'5px',marginBottom:'5px'}}>Asked {" "}{momentit(data.postedTimestamp)}</span>
			{data.tags && data.tags.length > 0 && (
				<>
				<Tags data={data}/>
				</>
			)}
            {
                data.answersList.length > 0 && data.answersList.map((obj,ind)=>{
                    return(
                        <>
                        <NameInfo data={obj} question={data} />
                        <Answer data={obj} question={data} val={tab} />
												{ind !== data.answersList.length - 1 && <hr style={hrStyles} />}
                        </>
                    )
                })
            }
			{
				data.answersList.length === 0 && 
				<p style={noAnswerText}>No Answer Yet!</p>
			}
			</div>
		</>
	)
}